import { TFunction, ApiError } from '@manigo/manigo-commons';

import { currentUserReducerName } from 'store/current-user/reducer';

import { INIT_EXCHANGE_COUNTDOWN_TIME, INIT_EXCHANGE_EQUALS_COUNTDOWN_TIME } from './actions.types';


export const createConfirmExchangeErrorMessage = (t: TFunction, error: ApiError) => {
    const handlers = [
        {
            predicate: () => error.message === 'Invalid signature.',
            handler: () => (t('sca:actionMessages.invalidSignature')),
        },
        {
            predicate: () => error.message === 'Invalid challenge.',
            handler: () => (t('sca:actionMessages.invalidChallenge')),
        },
        {
            predicate: () => error.message === 'Exchange offer expired',
            handler: () => (t('sca:actionMessages.exchangeOfferExpired')),
        },
        {
            predicate: () => true,
            handler: () => (t('unauthorised:genericApiError')),
        },
    ];

    return handlers.filter(({ predicate }) => predicate())[0].handler();
};


export const selectFxFlowWithRates = (state): boolean =>
    Boolean(state[currentUserReducerName]?.clientConfig?.generalSettings?.fxFlowWithRates);

export const getInitExchangeCountdownMs = (fxFlowWithRates: boolean): number =>
    fxFlowWithRates ? INIT_EXCHANGE_COUNTDOWN_TIME : INIT_EXCHANGE_EQUALS_COUNTDOWN_TIME;

